import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import SalesOrderView from '../../components/Sales/SalesOrderView';

const SalesOrderViewPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <SalesOrderView/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default SalesOrderViewPage;